import { routePermissions } from "@/constants/permission-user"

export const routesModule2 = [
  {
    path: "/server-management/dashboard",
    name: "serverManagementDashboard",
    component: () => import("@/views/serverManagement/Dashboard.vue"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/all-events",
    name: "serverManagementAllEvents",
    component: () => import("@/views/serverManagement/AllEvents.vue"),
    meta: {
      pageTitle: "All Events",
      breadcrumb: [
        {
          text: "All Events",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/server-management",
    name: "serverManagementServerManagement",
    component: () => import("@/views/serverManagement/ServerManagement.vue"),
    meta: {
      pageTitle: "Server Management",
      breadcrumb: [
        {
          text: "Server Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/server-management/:server_id",
    name: "serverManagementServerManagementDetail",
    component: () => import("@/views/serverManagement/ServerManagement.vue"),
    meta: {
      pageTitle: "Server Management",
      breadcrumb: [
        {
          text: "Server Management",
          active: true,
        },
      ],
      navActiveLink: "serverManagementServerManagement",
    },
  },
  {
    path: "/server-management/alert",
    name: "serverManagementAlert",
    component: () =>
      import("@/views/serverManagement/alert/AlertManagement.vue"),
    meta: {
      pageTitle: "Alert Management",
      breadcrumb: [
        {
          text: "Alert Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/alert/create",
    name: "createAlert",
    component: () =>
      import("@/views/serverManagement/alert/AlertModification.vue"),
    meta: {
      pageTitle: "Create Alert",
      breadcrumb: [
        {
          text: "Alert Management",
          active: false,
          to: "/server-management/alert",
        },
        {
          text: "Create Alert",
          active: true,
        },
      ],
      navActiveLink: "serverManagementAlert",
    },
  },
  {
    path: "/server-management/alert/edit/:id",
    name: "editAlert",
    component: () =>
      import("@/views/serverManagement/alert/AlertModification.vue"),
    meta: {
      pageTitle: "Edit Alert",
      breadcrumb: [
        {
          text: "Alert Management",
          active: false,
          to: "/server-management/alert",
        },
        {
          text: "Edit Alert",
          active: true,
        },
      ],
      navActiveLink: "serverManagementAlert",
    },
  },
  {
    path: "/server-management/report",
    name: "serverManagementReport",
    component: () => import("@/views/serverManagement/Report.vue"),
    meta: {
      pageTitle: "Report",
      breadcrumb: [
        {
          text: "Report",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/discovery",
    name: "serverManagementDiscovery",
    component: () => import("@/views/serverManagement/Discovery.vue"),
    meta: {
      pageTitle: "Discovery",
      breadcrumb: [
        {
          text: "Discovery",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/policy",
    name: "serverManagementPolicy",
    component: () =>
      import("@/views/serverManagement/policy/PolicyManagement.vue"),
    meta: {
      pageTitle: "Policy Management",
      breadcrumb: [
        {
          text: "Policy Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/server-management/policy/create",
    name: "createPolicy",
    component: () =>
      import("@/views/serverManagement/policy/CreateEditPolicy.vue"),
    meta: {
      pageTitle: "Create New Policy",
      breadcrumb: [
        {
          text: "Policy Management",
          active: false,
          to: "/server-management/policy",
        },
        {
          text: "Create New Policy",
          active: true,
        },
      ],
      navActiveLink: "serverManagementPolicy",
    },
  },
  {
    path: "/server-management/policy/edit/:id",
    name: "editPolicy",
    component: () =>
      import("@/views/serverManagement/policy/CreateEditPolicy.vue"),
    meta: {
      pageTitle: "Edit Policy",
      breadcrumb: [
        {
          text: "Policy Management",
          active: false,
          to: "/server-management/policy",
        },
        {
          text: "Edit Policy",
          active: true,
        },
      ],
      navActiveLink: "serverManagementPolicy",
    },
  },
].map((route) => {
  return {
    ...route,
    meta: {
      ...route.meta,
      module: "serverManagement",
      type: "internal",
      permission: routePermissions[route.name],
    },
  }
})
